import React from 'react';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import { getTencentAvatarSrc } from '@gp/utils/common';
import { GET_TEXT_WITH_HIGHLIGHT_OPTION } from '@gp/constants/const';

import './index.scss';

interface IEditUserInfoProps {
  text: string;
  // 需要高亮的文本（忽略大小写）
  highlightText?: string;
}

const EditUserInfo: React.FC<IEditUserInfoProps> = (props) => {
  const { text, highlightText } = props;
  const textFormatted = getTextWithHighlight(text, highlightText || '', GET_TEXT_WITH_HIGHLIGHT_OPTION);

  return (
    <div className="edit-user-info">
      <div className="edit-user-info-avatar">
        <GeneralImageNew domain="user" width={20} height={20} src={getTencentAvatarSrc(text)} />
      </div>
      <div className="edit-user-info-title">{textFormatted || '-'}</div>
    </div>
  );
};

export default React.memo(EditUserInfo);
